import "./shared/sentry"
import { MsalProvider } from "@azure/msal-react"
import { Toaster } from "@relex-solutions/fragments"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { ErrorBoundary } from "./shared/components/errorboundary/ErrorBoundary"
import { Router } from "./shared/components/router/router/Router"
import "./shared/i18n"
import { AuthProvider } from "./shared/context/auth/AuthProvider"
import { SessionRecoveryProvider } from "./shared/context/auth/SessionRecoveryProvider"
import { getMsalInstance } from "./shared/msal/loader"
import "./styles/grid.css"

const DEFAULT_STALE_TIME_MS = 1000 * 60 * 5 // 5 minutes

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: DEFAULT_STALE_TIME_MS
    }
  }
})

const { instance: msalInstance } = getMsalInstance()

export function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <MsalProvider instance={msalInstance}>
          <AuthProvider>
            <SessionRecoveryProvider>
              <ReactQueryDevtools initialIsOpen={false} />
              <Router />
              <Toaster />
            </SessionRecoveryProvider>
          </AuthProvider>
        </MsalProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
